import React from 'react';
import './RowsIndicator.css';

export function RowsIndicator({ loadedCount = 0, totalCount = 0 }) {
  const percentage = totalCount > 0 ? Math.round((loadedCount / totalCount) * 100) : 0;
  const widthPercent = totalCount > 0 ? Math.min(100, percentage) : 0;

  return (
    <div className="rows-indicator" aria-live="polite">
      <div className="rows-indicator__text">Showing {loadedCount} of {totalCount}</div>
      <div className="rows-indicator__track">
        <div className="rows-indicator__bar">
          <div
            className="rows-indicator__fill"
            style={{ width: `${widthPercent}%` }}
          />
        </div>
        <span className="rows-indicator__percent">{percentage}%</span>
      </div>
    </div>
  );
}

export default RowsIndicator;


